var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn-toggle',{staticClass:"ml-4",model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}},[_c('v-btn',{staticClass:"toggle-btn",class:[_vm.text === 'table' ? 'toggle-btn-active' : ''],attrs:{"value":"table"},on:{"click":function($event){return _vm.toggleMap('table')}}},[_c('v-icon',{class:[
                _vm.text === 'table'
                    ? 'toggle-icon-active'
                    : 'toggle-icon-inactive',
            ]},[_vm._v(" mdi-table-column ")])],1),_c('v-btn',{staticClass:"toggle-btn",class:[_vm.text === 'map' ? 'toggle-btn-active' : ''],attrs:{"value":"map"},on:{"click":function($event){return _vm.toggleMap('map')}}},[_c('v-icon',{class:[
                _vm.text === 'map' ? 'toggle-icon-active' : 'toggle-icon-inactive',
            ]},[_vm._v(" mdi-map ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }